import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

class LessonTypeDropdownList extends Component {
	constructor(props) {
		super(props);
		this.handleSelectChange = this.handleSelectChange.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		const { onChange, value, defaultSelectedId } = nextProps;

		// trigger onChange if dropdown value is set to Active year on initial load
		if (value == null && defaultSelectedId && onChange) {
			onChange(defaultSelectedId);
		}
	}

	handleSelectChange(selectedId) {
		const { onChange } = this.props;
		if (onChange) {
			onChange(selectedId);
		}
	}

	render() {
		const { data, name, value, onChange, hideEmptyOption, emptyLabel, defaultSelectedId, ...rest } = this.props;

		const selectedId = value || defaultSelectedId;
		const selected = selectedId && data.find(x => x.id === selectedId);

		return <Dropdown>
			<Dropdown.Toggle title={<span>{(selected && selected.displayName) || emptyLabel} <FontAwesomeIcon icon={faChevronDown} /></span>} noCaret {...rest} />
			<Dropdown.Menu className='dashboard-dropdown-menu'>
				{hideEmptyOption || data.length < 2 || <MenuItem key={0} eventKey='' onSelect={this.handleSelectChange}><span>{emptyLabel}</span></MenuItem>}
				{data.map(type => {
					return <MenuItem key={type.id} eventKey={type.id} onSelect={this.handleSelectChange}>
						<span >{type.displayName}</span>
					</MenuItem>;
				})}
			</Dropdown.Menu>
		</Dropdown>;
	}
}

const mapStateToProps = (state) => {
	const {
		lookups: { allLessonTypes }
	} = state;

	return {
		data: Object.values(allLessonTypes)
	};
};

export default connect(mapStateToProps, {})(LessonTypeDropdownList);